import React, { useState, useMemo } from "react";
import { useAuthContext } from "@src/context/authContext";
import { useAdminContext } from "@src/context/adminContext";
import Form from "@src/components/forms/Form";
import {
  Button,
  Divider,
  DropDown,
  FormInput,
  Loader,
} from "@src/components/atoms";
import AdminHooks from "@src/context/hooks/adminHooks";
import { LayoutStateWrapper } from "./LayoutStateWrapper";
import { useToastContext } from "@src/context/toastContext";

const baseDCKey = "layouts";

const formatdataOptions = (behiveOutput, customerCode) => {
  const dataOptions = [
    {
      text: "non selected",
      value: null,
    },
  ];
  if (behiveOutput) {
    const graphURLStrings = behiveOutput.filter((output) =>
      output.includes(`/${customerCode.toLowerCase()}/`),
    );
    for (let i = 0; i < graphURLStrings.length; i++) {
      const graphName = graphURLStrings[i]
        .split("/")
        .pop()
        .replace(".json", "")
        .replaceAll("_", " ");
      dataOptions.push({
        text: graphName,
        value: graphURLStrings[i],
      });
    }
  }
  return dataOptions;
};

export const BehiveGridLayoutEditorPage = () => {
  const { showToast } = useToastContext();
  const auth = useAuthContext();
  const { customers, selectedCustomer } = useAdminContext();
  const [customer, setCustomer] = useState(
    selectedCustomer
      ? selectedCustomer
      : customers.find((c) => c.customerCode === "VS"),
  );
  const [customerCode, setCustomerCode] = useState(
    selectedCustomer ? selectedCustomer.customerCode : "VS",
  );
  const [currentPageValue, setCurrentPageValue] = useState("overview");

  const {
    data: dynamicContent,
    isLoading: isDCLoading,
    isError: isDCError,
  } = AdminHooks.useGetDynamicContent(auth.activeRole, "global");

  const {
    data: behaviours,
    isLoading: isBehavioursLoading,
    isError: isBehavioursError,
  } = AdminHooks.useGetBehaviours(auth.activeRole, customerCode);

  const {
    data: behiveOutput,
    isLoading: isbehiveOutputLoading,
    isError: isbehiveOutputError,
  } = AdminHooks.useGetBehiveOutputs(auth.activeRole, customerCode);

  const saveMutation = AdminHooks.useSaveDynamicContent();
  const deleteMutation = AdminHooks.useDeleteDynamicContent();

  const filteredBehaviours = useMemo(() => {
    const displayBehaviours = behaviours?.filter((b) => b.enabled);
    return displayBehaviours;
  }, [behaviours]);

  const filteredBehiveOutput = useMemo(() => {
    const prodOutput = behiveOutput?.keysJson.filter((o) =>
      o.includes(`/${customerCode.toLowerCase()}/`),
    );
    return prodOutput;
  }, [behiveOutput]);

  console.log(filteredBehiveOutput);

  const currentSelectedGrid =
    dynamicContent?.global[
      `${baseDCKey}__${customerCode.toLowerCase()}__${currentPageValue}`
    ];
  const initialGrid = currentSelectedGrid
    ? JSON.parse(currentSelectedGrid[0].content_value)
    : { sections: [] };
  const dataOptions = formatdataOptions(filteredBehiveOutput, customerCode);
  const behaviourOptions = useMemo(() => {
    let options = [];
    console.log(filteredBehaviours);
    for (let b = 0; b < filteredBehaviours?.length; b++) {
      options.push({
        text: filteredBehaviours[b].acronym,
        value: filteredBehaviours[b].acronym,
      });
    }
    return options;
  }, [filteredBehaviours]);

  const saveLayout = async (grid) => {
    console.log("save layout");
    saveMutation.mutateAsync({
      industry: "global",
      lang: "en",
      name: `${baseDCKey}__${customerCode.toLowerCase()}__${currentPageValue}`,
      content: [JSON.stringify(grid)],
    });
    showToast(`Saved Behive layout`, "success");
  };

  const deleteLayout = () => {
    console.log("delete layout");
    deleteMutation.mutateAsync({
      industry: "global",
      lang: "en",
      name: `${baseDCKey}__${customerCode.toLowerCase()}__${currentPageValue}`,
    });
  };

  return (
    <>
      {isDCLoading || isBehavioursLoading || isbehiveOutputLoading ? (
        <Loader />
      ) : (
        <LayoutStateWrapper
          currentPageValue={currentPageValue}
          customer={customer}
          customerCode={customerCode}
          setCurrentPageValue={setCurrentPageValue}
          setCustomer={setCustomer}
          setCustomerCode={setCustomerCode}
          dynamicContent={dynamicContent}
          customers={customers}
          filteredBehaviours={filteredBehaviours}
          dataOptions={dataOptions}
          behaviourOptions={behaviourOptions}
          initialGrid={initialGrid}
          saveLayout={saveLayout}
          deleteLayout={deleteLayout}
        />
      )}
    </>
  );
};
